<template>
  <div class="flex-row align-items-center my-5 py-5">
    <div class="container my-5 py-4">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">
                <i class="fa fa-spinner"></i>
            </h1>
            <h4 class="pt-3">Mai avem de lucru!</h4>
            <p class="text-muted">Te rugăm să ne contactezi pentru alte tipuri de polite.</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkInProgress'
}
</script>
